systemSettingsCloseButton = {};

systemSettingsCloseButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return true;
  };

  button.onPressedCallback = function () {
    let systemSettingsBox = resourceManager.get("systemSettings:systemSettingsBox");
    systemSettingsBox.showsystemSettingsBoxPanel(false);
    soundManager.play("buttonPressV3Exit");
  };

  return button;
};

systemSettingsCloseButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
systemSettingsCloseButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "systemSettingsCloseButton",
  systemSettingsCloseButton.create,
  systemSettingsCloseButton.initialise,
  systemSettingsCloseButton.getFilesRequired
);
